export default function ConfigurationEmailConfiguration($translatePartialLoaderProvider) {
	// On configure la gestion de la traduction en lui indiquant quel fichier json il doit charger pour ce module
	$translatePartialLoaderProvider.addPart('configuration.email');
}
ConfigurationEmailConfiguration.$inject = ['$translatePartialLoaderProvider'];
